// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiePopUp_container__Nya8I","privacyPolicy":"CookiePopUp_privacyPolicy__f1KzS"};